<template>
  <div>
    <v-dialog
      width="400px"
      :title="`Edit ${title} Customer`"
      :visible.sync="dialogVisible"
      :scrollbar="false"
      @open="onOpen"
      @closed="onClosed"
    >
      <div v-loading="loading" element-loading-text="Loading...">
        <el-form
          ref="form"
          :model="form"
          label-position="top">
          <el-form-item class="se-name" prop="name" label="Customer Name：">
            <strong>{{ form.name }}</strong>
          </el-form-item>
          <el-form-item prop="userIds" :label="title">
            <el-select
              v-model="form.userIds"
              :placeholder="`Please select ${title}`"
              filterable
              multiple>
              <el-option v-for="(item,i) in crpList" :label="item.TAName" :value="item.TAID" :key="i"/>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="actions">
          <el-button type="primary" @click="onConfirm" :loading="saving">
            {{ saving ? "Saving" : "Save" }}
          </el-button>
          <el-button @click="onClosed">Cancel</el-button>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import * as _ from "lodash";

export default {
  name: "EditCustomerDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    data: Object,
    roleType: String,
    title: String
  },
  data() {
    return {
      form: {
        seId: "",
        name: "",
        userIds: [],
        deletes: []
      },
      formRules: {
        userIds: {
          required: true,
          type: "array",
          message: `Please select ${this.title}`
        }
      },
      crpList: [],
      originalSelected: [],
      loading: false,
      saving: false
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value)
      }
    }
  },
  methods: {
    onOpen() {
      if (this.data) {
        this.loading = true;
        this.$axios
          .all([
            this.axios.get(`/user/taList/${this.roleType}`),
            this.axios.get(`/customer/getLeaderList/${this.roleType}/${this.data.SEID}`),
          ])
          .then((res) => {
            this.loading = false;
            this.handleCRPListResp(res[0])
            this.handleSELeaderResp(res[1])
          });
      }
    },
    onClosed() {
      this.$refs.form.resetFields();
      this.$emit("update:visible", false);
      this.$emit("update:data", null);
    },
    handleCRPListResp({code, data, msg}) {
      if (code === 200) {
        this.crpList = data;
      } else {
        this.$message.error(msg);
      }
    },
    handleSELeaderResp({code, data}) {
      if (code === 200) {
        this.$nextTick(() => {
          this.originalSelected = _.cloneDeep(data);
          Object.assign(this.form, {
            seId: this.data.SEID,
            name: this.data.SEName,
            userIds: data.map(({UserID}) => UserID)
          });
        });
      }
    },
    onConfirm() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return
        }

        const adds = this.form.userIds.filter(id => {
          return !this.originalSelected.some(({UserID}) => UserID === id);
        });

        const deletes = _.chain(this.originalSelected).filter(({UserID}) => {
          return !this.form.userIds.some(id => id === UserID);
        }).map(({ID, UserID, SEID}) => {
          return {ID, UserID, SEID};
        }).value();

        this.saving = true;
        this.axios.post(`/customer/editLeader/${this.roleType}/${this.form.seId}`, {
          adds,
          deletes
        }).then(({code, msg}) => {
          if (code === 200) {
            this.onClosed();
            this.$emit("success");
            this.$message.success("Save successfully");
          } else {
            this.$message.error(msg);
          }
          this.saving = false;
        }).catch(() => {
          this.saving = false;
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form {
  .el-form-item {
    margin-bottom: 10px;

    &.se-name {
      display: flex;
    }
  }

  ::v-deep {
    .el-form-item__label {
      padding: 0 !important;
    }
  }

  .el-input,
  .el-select {
    width: 100%;
  }
}

.actions {
  margin-top: 20px;
  text-align: center;
}

::v-deep {
  .el-dialog__header {
    padding-bottom: 0;
  }

  .el-dialog__body {
    padding: 20px 40px 20px;
  }

  .el-dialog__footer {
    padding: 0;
  }
}
</style>
